<template>
  <v-card
    v-if="reload"
    class="ma-0 px-1 app-form-page app-form-page--fixed app-form-page--customer"
    width="100%"
    flat
  >
    <v-app-bar flat class="my-0 mb-0 py-0 px-2 app-form-toolbar" dense height="40">
      <v-toolbar-title class="app-form-toolbar__title me-3">
        {{ $t("customer&detail") }}
      </v-toolbar-title>
      <v-spacer />
      <v-checkbox
        v-model="status"
        class="mt-0 mx-3 app-form-toolbar__status"
        hide-details
        dense
        :label="$t('active')"
        value="active"
      />
      <div class="app-form-toolbar__actions">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              small
              class="app-form-toolbar__btn"
              v-on="on"
              @click="goTo('customer')"
            >
              <v-icon color="teal">mdi-plus-box-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("newCustomer") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              small
              class="app-form-toolbar__btn"
              v-on="on"
              @click="goTo('customerList')"
            >
              <v-icon color="primary">mdi-format-list-numbered</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("customerList") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              small
              class="app-form-toolbar__btn"
              v-on="on"
              @click="$router.go(-1)"
            >
              <v-icon color="primary">mdi-arrow-left</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("back") }}</span>
        </v-tooltip>
      </div>
    </v-app-bar>

    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />

    <v-form v-if="render" ref="form" v-model="valid" class="app-form-page__form">
      <v-tabs v-model="activeTab" class="app-form-page__tabs">
        <v-tab>{{ $t("public-information") }}</v-tab>
        <v-tab v-if="activeUser"> {{ $t("userInformation") }}&{{ $t("access") }} </v-tab>
        <v-tab>{{ $t("Integrator") }}</v-tab>
        <v-tab :disabled="!documentPermmission">
          {{ $t("documents") }}
        </v-tab>
        <v-tab v-if="activeUser && branchesItems != null">
          {{ $t("smses") }}
        </v-tab>
        <v-tab v-if="personnely">{{ $t("personnely") }}</v-tab>

        <v-tab-item>
          <v-container>
            <v-row class="pt-1 pa-0">
              <v-col cols="12" md="1">
                <v-row>
                  <v-col cols="12" :class="{ 'mb-6': $vuetify.breakpoint.mobile }">
                    <file-picker
                      ref="refFilePicker"
                      v-model="imagePicker"
                      :label="$t('uploadImage')"
                      :avatar="true"
                      :multiple="false"
                      extensions="image/png, image/gif, image/jpeg"
                      type-prop="personAvatar"
                      :val="imagePickerVal ? imagePickerVal : null"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="ps-5" md="11">
                <v-row>
                  <v-col cols="12" md="2">
                    <v-btn-toggle
                      v-model="personType"
                      mandatory
                      dense
                      class="d-flex"
                      style="width: 100%"
                    >
                      <v-btn
                        value="real"
                        height="35"
                        class="flex-grow-1"
                        style="color: #2b2b2b"
                      >
                        {{ $t("Individual") }}
                      </v-btn>
                      <v-btn
                        value="company"
                        height="35"
                        class="flex-grow-1"
                        style="color: #2b2b2b"
                      >
                        {{ $t("legal") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col cols="12" md="10" class="pa-0 pt-2">
                    <v-container class="pa-0 m-0 d-flex ps-5 gap-3">
                      <v-checkbox
                        v-model="lead"
                        class="mt-0"
                        :label="$t('lead')"
                        value="active"
                        :disabled="personel == 'active' ? true : false"
                      />
                      <!-- add check personnel check box  --->
                      <v-checkbox
                        v-if="salaryPermission"
                        v-model="personnely"
                        class="mt-0"
                        :label="$t('personnely')"
                        value="active"
                        :disabled="lead == 'active' ? true : false"
                      />
                      <v-checkbox
                        v-model="personel"
                        class="mt-0"
                        :label="$t('user')"
                        value="active"
                        :disabled="lead == 'active' ? true : false"
                      />
                      <span v-if="learningPermission" class="d-flex">
                        <v-checkbox
                          v-model="student"
                          class="mt-0"
                          :label="$t('student', { name: $store.state.studentLabel })"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                        <v-checkbox
                          v-model="teacher"
                          class="mt-0 ms-2"
                          :label="$t('teacher')"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                      </span>
                      <span v-if="commissionPermission" class="d-flex">
                        <v-checkbox
                          v-model="visitor"
                          class="mt-0 ms-2"
                          :label="$t('visitor')"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                      </span>
                      <span v-if="investorPermission" class="d-flex">
                        <v-checkbox
                          v-model="investor"
                          class="mt-0 ms-2"
                          :label="$t('investor')"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                      </span>
                      <span v-if="translationPermission" class="d-flex">
                        <v-checkbox
                          v-model="translator"
                          class="mt-0"
                          :label="$t('translator')"
                          value="active"
                          :disabled="lead == 'active' ? true : false"
                        />
                      </span>
                    </v-container>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col v-if="personType === 'real'" cols="12" md="2">
                    <v-btn-toggle
                      v-model="gender"
                      mandatory
                      dense
                      class="d-flex"
                      style="width: 100%"
                    >
                      <v-btn
                        value="man"
                        height="35"
                        class="flex-grow-1"
                        style="color: #2b2b2b"
                      >
                        {{ $t("man") }}
                      </v-btn>
                      <v-btn
                        value="woman"
                        height="35"
                        class="flex-grow-1"
                        style="color: #2b2b2b"
                      >
                        {{ $t("woman") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="firstname"
                      :label="$t('name')"
                      :rules="[
                        (v) => !!v || $t('is-required'),
                        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                      ]"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col v-show="gender !== 'company'" cols="12" md="2">
                    <v-text-field
                      v-model="lastname"
                      :label="$t('last-name')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="nationalCode"
                      :label="$t('national-code')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="mobile"
                      :label="$t('mobile')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-expansion-panels v-model="panel" multiple class="mt-8">
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("otherCantactInfo") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("email") }} , {{ $t("phone") }} , {{ $t("address") }} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="email"
                        :label="$t('email')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="phone"
                        :label="$t('phone')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col cols="12" md="2">
                      <aicomplete
                        ref="refCountry"
                        v-model="country"
                        title="country"
                        type="country"
                        :val="country"
                        :new-btn="true"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <aicomplete
                        ref="refState"
                        v-model="state"
                        title="state"
                        type="state"
                        :val="state"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="country ? country.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <aicomplete
                        ref="refCity"
                        v-model="city"
                        title="city"
                        type="city"
                        :val="city"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="state ? state.id : null"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mb-2">
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="address"
                        outlined
                        clearable
                        dense
                        :label="$t('address')"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon> mdi-map-marker </v-icon>
                          <!--                    <div class="mt-1">-->
                          <!--                      {{(country ? country.name : '')}}-->
                          <!--                      {{(state ? ' - ' + state.name : '')}}-->
                          <!--                      {{(city ? ' - ' + city.name + ' - ' : '')}}-->
                          <!--                    </div>-->
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="postalCode"
                        :label="$t('postal-code')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("grouping,tags") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("tag") }} , {{ $t("category") }} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col cols="12" md="3">
                      <aicomplete
                        ref="refCategory"
                        v-model="category"
                        title="category"
                        type="accountCategory"
                        :val="category"
                        :new-btn="true"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <tag v-model="tag" :solo="false" :input="tag" />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("otherIdentityInformation") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("birthDate") }} , {{ $t("financial-code") }} , ...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content eager>
                  <v-row class="mb-2">
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        ref="refBusinessName"
                        v-model="businessName"
                        :label="$t('business-name')"
                        outlined
                        clearable
                        dense
                      />
                      <!-- :rules="[personnelyConditionRule]" -->
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        ref="refFinancialCode"
                        v-model="financialCode"
                        :label="$t('financial-code')"
                        outlined
                        clearable
                        dense
                      />
                      <!-- :rules="[(v) => !!v || $t('is-required')]" -->
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="customerBranch"
                        :label="$t('branch-name')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="customerTaxCodeBranch"
                        :label="$t('branch-tax-code')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <template>
                        <v-text-field
                          ref="refBirthDate"
                          id="date"
                          v-model="birthDate"
                          :label="$t('birthDate')"
                          single-line
                          clear-icon="flaticon2-close-cross"
                          outlined
                          dense
                          clearable
                          :rules="[personnelyConditionRule]"
                        />

                        <date-picker
                          v-model="birthDate"
                          element="date"
                          auto-submit
                          :color="
                            this.$vuetify.theme.themes[
                              this.$vuetify.theme.isDark ? 'dark' : 'light'
                            ].primary
                          "
                        />
                      </template>
                    </v-col>

                    <v-col cols="12" md="2" class="mb-2">
                      <aicomplete
                        ref="refStatePlaceofBirth"
                        v-model="statePlaceofBirth"
                        title="statePlaceofBirth"
                        type="state"
                        :val="statePlaceofBirth"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="country ? country.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <aicomplete
                        ref="refCityPlaceofBirth"
                        v-model="cityPlaceofBirth"
                        title="cityPlaceofBirth"
                        type="city"
                        :val="cityPlaceofBirth"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="state ? state.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        ref="refFathersName"
                        v-model="fathersName"
                        :label="$t('fathersName')"
                        outlined
                        clearable
                        dense
                        :rules="[personnelyConditionRule]"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        ref="refBirthCertificateNumber"
                        v-model="BirthCertificateNumber"
                        :label="$t('Birth Certificate Number')"
                        outlined
                        clearable
                        dense
                        :rules="[personnelyConditionRule]"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <template>
                        <v-text-field
                          ref="refDateOfBirthCertificate"
                          id="dateCertificate"
                          v-model="dateOfBirthCertificate"
                          :label="$t('dateOfBirthCertificate')"
                          single-line
                          clear-icon="flaticon2-close-cross"
                          outlined
                          dense
                          clearable
                          :rules="[personnelyConditionRule]"
                        />

                        <date-picker
                          v-model="dateOfBirthCertificate"
                          element="dateCertificate"
                          auto-submit
                          :color="
                            this.$vuetify.theme.themes[
                              this.$vuetify.theme.isDark ? 'dark' : 'light'
                            ].primary
                          "
                        />
                      </template>
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <aicomplete
                        ref="refStatePlaceOfBirthCertificate"
                        v-model="statePlaceOfBirthCertificate"
                        title="statePlaceOfBirthCertificate"
                        type="state"
                        :val="statePlaceOfBirthCertificate"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="country ? country.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <aicomplete
                        ref="refCityPlaceOfBirthCertificate"
                        v-model="cityPlaceOfBirthCertificate"
                        title="cityPlaceOfBirthCertificate"
                        type="city"
                        :val="cityPlaceOfBirthCertificate"
                        :new-btn="true"
                        :data="JSON.stringify({ parent: country ? country.id : null })"
                        :parent="state ? state.id : null"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <FlexibleAutocomplete
                        v-model="education_field"
                        title="certificate"
                        type="education_field"
                        :multiple="false"
                        :currency="currencyId"
                        :fetchData="fetchApi"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <FlexibleAutocomplete
                        v-model="magor"
                        title="magor"
                        type="magor"
                        :multiple="false"
                        :currency="currencyId"
                        :fetchData="fetchApi"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="mb-2">
                      <v-text-field
                        v-model="childCount"
                        :label="$t('childCount')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="d-flex">
                      <v-checkbox
                        v-model="married"
                        class="mt-0"
                        :label="$t('married')"
                        :disabled="lead == 'active' ? true : false"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-show="$store.state.isMainYear">
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("financialInformation") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("initialRemainingAndFinancialStatus") }}
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="nature_initial_price"
                        :label="$t('natureAccount')"
                        :items="natureItems"
                        height="30"
                        dense
                        outlined
                        :disabled="!initialCheck"
                        item-value="value"
                        item-text="text"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <money
                        v-model="initial_price"
                        :label="$t('initialPrice')"
                        :dense="true"
                        :outlined="true"
                        :solo="false"
                        :clearable="true"
                        value-when-is-empty=""
                        :options="options"
                        :disabled="!initialCheck"
                        class="mb-3 dense"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="!isMobile && customFieldsPermission">
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("customFields") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("customeFeildDescrible") }}
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <custom-fields
                    v-model="customFields"
                    :value="customFields"
                    typeProp="accountCustomFields"
                    class="px-4"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header style="font-size: 14px">
                  <div>
                    <div>{{ $t("otherInformation") }}</div>
                    <div class="abr-subtitle mt-2">
                      {{ $t("branch") }} , {{ $t("content") }} ,
                      {{ $t("attractionMethod") }} , {{ $t("Custom financial ID") }}...
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mb-2">
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="custom_code"
                        :label="$t('Custom financial ID')"
                        outlined
                        clearable
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <autocomplete
                        v-model="branch"
                        :title="$t('branch')"
                        type="branch"
                        :set-init="true"
                        :value="branch"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <autocomplete
                        v-model="attractionMethod"
                        :title="$t('attractionMethod')"
                        type="attractionMethod"
                        :value="attractionMethod"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <description v-model="content" :outlined="true" type="sell" />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-tab-item>
        <v-tab-item v-if="activeUser">
          <v-container>
            <v-row>
              <v-col cols="12" md="3">
                <v-btn-toggle
                  v-model="personnelType"
                  mandatory
                  dense
                  class="d-flex"
                  style="width: 100%"
                >
                  <v-btn
                    value="personnel"
                    height="35"
                    class="flex-grow-1"
                    style="color: #2b2b2b"
                  >
                    {{ $t("personnel") }}
                  </v-btn>
                  <v-btn
                    value="customer"
                    height="35"
                    class="flex-grow-1"
                    style="color: #2b2b2b"
                  >
                    {{ $t("customer") }}
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="username"
                  :label="$t('username')"
                  outlined
                  clearable
                  dense
                  :disabled="personelStatus == 'active'"
                  @change="checkUser"
                />
              </v-col>
              <template v-if="personnelType === 'personnel'">
                <v-col v-if="!id" cols="12" md="3">
                  <v-text-field
                    v-model="password"
                    :label="$t('password')"
                    outlined
                    clearable
                    dense
                    :disabled="isLoading || (!isLoading && isUserRepitetive != null)"
                    :loading="isLoading"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <autocomplete
                    ref="refRole"
                    v-model="role"
                    :title="$t('userRole')"
                    type="role"
                    :set-init="true"
                    :value="role"
                  />
                </v-col>
              </template>
            </v-row>
            <v-row v-if="personnelType === 'personnel'">
              <v-col cols="12" md="3" class="mb-2">
                <autocomplete
                  ref="refEntrepot"
                  v-model="entrepotAccess"
                  :title="$t('entrepotAccess')"
                  :multiple="true"
                  :value="entrepotAccess"
                  :data="JSON.stringify({ withoutAccess: 'active' })"
                  type="entrepot"
                  :disabled="!$store.state.access ? true : false"
                />
              </v-col>
              <v-col cols="12" md="3" class="mb-2">
                <aicomplete
                  v-model="branchAccess"
                  title="branch"
                  type="branch"
                  :val="branchAccess"
                  :multiple="true"
                  :new-btn="true"
                />
              </v-col>
              <v-col v-if="isSupport" cols="12" md="3" class="mb-2">
                <autocomplete
                  v-model="departmentAccess"
                  :title="$t('departmentAccess')"
                  :multiple="true"
                  :value="departmentAccess"
                  type="departments"
                  :disabled="!$store.state.access ? false : false"
                />
              </v-col>
              <v-col cols="12" md="3" class="mb-2">
                <autocomplete
                  v-model="bank"
                  :title="$t('bank') + '/' + $t('cash') + '/' + $t('petty')"
                  type="allBankCash"
                  :outlined="true"
                  :multiple="true"
                  :value="bank"
                />
              </v-col>
              <v-col md="1">
                <v-checkbox
                  v-model="admin"
                  class="mt-0"
                  :label="$t('admin')"
                  value="active"
                  :disabled="!$store.state.admin ? true : false"
                />
              </v-col>
              <v-col md="3">
                <v-checkbox
                  v-model="deactiveChangeSellPrice"
                  class="mt-0"
                  :label="$t('deactiveChangeSellPrice')"
                  value="active"
                  :disabled="!$store.state.access ? true : false"
                />
              </v-col>
              <v-col md="3">
                <v-checkbox
                  v-model="deactiveBranchAccess"
                  class="mt-0"
                  :label="$t('deactiveBranchAccess')"
                  value="active"
                  :disabled="!$store.state.access ? true : false"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox
                  v-model="configs.showInStockProduct"
                  class="mt-0"
                  :label="$t('show only inStock product while searching')"
                  value="active"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <v-row class="pa-0 ma-0">
              <v-tabs vertical>
                <v-tab>
                  <v-icon class="me-3"> mdi-wordpress </v-icon>
                  {{ $t("woocommerce") }}
                </v-tab>
                <v-tab align="right">
                  <v-icon class="me-3"> mdi-shopping-outline </v-icon>
                  {{ $t("digikala") }}
                </v-tab>
                <v-tab align="right">
                  <v-icon class="me-3"> mdi-web </v-icon>
                  {{ $t("portal") }}
                </v-tab>
                <v-tab align="right">
                  <img width="20" class="me-4" src="@/assets/sazito.png" />
                  {{ $t("sazito") }}
                </v-tab>
                <v-tab align="right">
                  <img
                    width="20"
                    class="me-4"
                    src="@/assets/integrators/logo-magnet.png"
                  />
                  {{ $t("magnet") }}
                </v-tab>
                <v-tab align="right">
                  <img width="20" class="me-4" src="@/assets/webzi.png" />
                  {{ $t("webzi") }}
                </v-tab>
                <v-tab-item>
                  <v-container>
                    <v-row class="mx-0">
                      <v-col cols="6" class="px-0">
                        <v-btn
                          color="primary"
                          class="mr-0"
                          outlined
                          :loading="isLoading"
                          @click="addWoocommerceIdItems"
                        >
                          {{ $t("addId") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-for="(item, h) in woocommerceIdItems" :key="h">
                      <v-col cols="12" md="3" class="mb-0">
                        <autocomplete
                          v-model="item.woocommercePanelName"
                          :title="$t('woocommercePanelName')"
                          :value="item.woocommercePanelName"
                          type="woocommercePanelName"
                        />
                      </v-col>
                      <v-col cols="12" md="2" class="mb-0">
                        <v-text-field
                          v-model="item.woocommerceId"
                          :label="$t('woocommerceId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" class="mb-0">
                        <v-btn
                          color="pink"
                          small
                          outlined
                          height="32"
                          @click="removeWoocommerceId(item)"
                        >
                          <v-icon> mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="digikalaId"
                          :label="$t('digikalaId')"
                          height="20"
                          dense
                          outlined
                          :disabled="true"
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="portalId"
                          :label="$t('portalId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="sazitoId"
                          :label="$t('sazitoId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="magnetId"
                          :label="$t('magnetId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="webziId"
                          :label="$t('webziId')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-checkbox
                          v-model="webziSeller"
                          class="mt-1 mx-3"
                          :label="$t('webziSeller')"
                          value="active"
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="3" class="mb-0">
                        <v-text-field
                          v-model="webziSellerCommission"
                          :label="$t('webziSellerCommission')"
                          height="20"
                          dense
                          outlined
                          class="mb-1 dense"
                          clearable
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item class="app-form-documents-pane">
          <div class="app-form-body">
            <v-container class="app-form-container app-form-documents pt-3 pb-2">
              <form-attachment-doc
                ref="refFilePickerDocument"
                v-model="attachments"
                type-prop="account"
                :val="id && attachments ? attachments : null"
              />
            </v-container>
          </div>
        </v-tab-item>
        <v-tab-item v-if="activeUser && branchesItems != null" class="pa-4">
          <v-expansion-panels v-model="panelBranch" class="branch-panel" multiple>
            <v-expansion-panel
              v-for="(branch, index) in branchesItems"
              :key="branch.id || index"
            >
              <v-expansion-panel-header>
                <v-container class="d-flex align-center gap-2 pa-0">
                  <v-icon size="15">mdi-source-branch</v-icon>
                  <v-card-text class="pa-0 text-body-1">{{ branch.name }}</v-card-text>
                </v-container>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container class="pa-0">
                  <v-treeview
                    v-model="branch.smsTree"
                    :items="treeItems"
                    item-key="id"
                    selectable
                    open-on-click
                    selected-color="primary"
                  >
                    <template v-slot:label="{ item }">
                      {{ item.name }}
                    </template>
                  </v-treeview>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>
        <!-- personnely tab content --->
        <v-tab-item class="pa-4">
          <v-expansion-panels v-model="panelPersonnely" class="mt-8">
            <!-- Insurer info --->
            <v-expansion-panel>
              <v-expansion-panel-header style="font-size: 14px">
                <div>
                  <div>{{ $t("InsurerInformation") }}</div>
                  <div class="abr-subtitle mt-2">
                    {{ $t("InsurerName") }} , {{ $t("InsurerNumber") }} ,
                    {{ $t("Record") }} , ...
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mb-2">
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="insurance_job_position"
                      title="InsurerRole"
                      type="insurance_job_position"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="insurance_type"
                      title="InsurerType"
                      type="insurance_type"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="InsurerName"
                      :label="$t('InsurerName')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="InsurerNumber"
                      :label="$t('InsurerNumber')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="InsurerRecordToMonth"
                      :label="$t('InsurerRecordToMonth')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- work info --->
            <v-expansion-panel>
              <v-expansion-panel-header style="font-size: 14px">
                <div>
                  <div>{{ $t("workInformation") }}</div>
                  <div class="abr-subtitle mt-2">
                    {{ $t("personnelCode") }} , {{ $t("workshop") }} ,{{
                      $t("jobPosition")
                    }}
                    , ...
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mb-2">
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="personnelCode"
                      :label="$t('personnelCode')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="workshop"
                      title="workshop"
                      type="WorkshopType"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchWorkshopApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="finance_job_position"
                      title="AssetsRole"
                      type="finance_job_position"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <template>
                      <v-text-field
                        id="startToWork"
                        v-model="startToWork"
                        :label="$t('startToWork')"
                        single-line
                        clear-icon="flaticon2-close-cross"
                        outlined
                        dense
                        clearable
                      />

                      <date-picker
                        v-model="startToWork"
                        element="startToWork"
                        auto-submit
                        :color="
                          this.$vuetify.theme.themes[
                            this.$vuetify.theme.isDark ? 'dark' : 'light'
                          ].primary
                        "
                      />
                    </template>
                  </v-col>
                  <v-col cols="12" md="2">
                    <template>
                      <v-text-field
                        id="EndToWork"
                        v-model="EndToWork"
                        :label="$t('EndToWork')"
                        single-line
                        clear-icon="flaticon2-close-cross"
                        outlined
                        dense
                        clearable
                      />

                      <date-picker
                        v-model="EndToWork"
                        element="EndToWork"
                        auto-submit
                        :color="
                          this.$vuetify.theme.themes[
                            this.$vuetify.theme.isDark ? 'dark' : 'light'
                          ].primary
                        "
                      />
                    </template>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="bankName"
                      :label="$t('bank-name')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="SalaryAccountNumber"
                      :label="$t('SalaryAccountNumber')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="type_of_employment"
                      title="employmentType"
                      :currency="currencyId"
                      type="type_of_employment"
                      :multiple="false"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="type_of_contract"
                      title="contractType"
                      type="type_of_contract"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Service info --->
            <v-expansion-panel>
              <v-expansion-panel-header style="font-size: 14px">
                <div>
                  <div>{{ $t("Serviceinformation") }}</div>
                  <div class="abr-subtitle mt-2">
                    {{ $t("ServiceStatus") }} , {{ $t("jobCategory") }} ,{{
                      $t("ServicePlace")
                    }},...
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mb-2">
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="soldier_status"
                      title="Military Service Status"
                      type="soldier_status"
                      :currency="currencyId"
                      :multiple="false"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="job_field"
                      title="jobCategory"
                      type="job_field"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      v-model="ServicePlace"
                      :label="$t('ServicePlace')"
                      outlined
                      clearable
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="soldier_location_type"
                      title="ServicePlaceStatus"
                      type="soldier_location_type"
                      :multiple="false"
                      :currency="currencyId"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <FlexibleAutocomplete
                      v-model="exemption_type"
                      title="ExemptType"
                      type="exemption_type"
                      :currency="currencyId"
                      :multiple="false"
                      :fetchData="fetchApi"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>
      </v-tabs>

      <div class="app-form-page__actions">
        <div class="app-form-page__actions-inner">
          <v-btn
            v-if="!id"
            color="primary"
            depressed
            class="app-form-action-btn"
            :loading="isLoading"
            @click="create"
          >
            {{ $t("submit") }}
          </v-btn>
          <v-btn
            v-if="id"
            color="primary"
            depressed
            class="app-form-action-btn"
            :loading="isLoading"
            @click="update"
          >
            {{ $t("submit") }}
          </v-btn>
          <v-btn
            color="primary"
            outlined
            depressed
            class="app-form-action-btn"
            @click="goTo('customerList')"
          >
            {{ $t("customerList") }}
          </v-btn>
        </div>
      </div>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
export default {
  name: "CustomerFormDesktopView",
};
</script>

<style>
/* Unscoped for Bridge (View is not mounted). Rules match customer.vue HEAD. */
.v-text-field--outlined .v-label {
  top: 6px;
}
.branch-panel .v-expansion-panel::before {
  box-shadow: none;
}
.v-card__text {
  width: auto;
}
.branch-panel .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #c0c0c026;
}
.branch-panel .v-expansion-panel {
  border: 1px solid silver;
  margin-bottom: 7px;
  border-radius: 4px;
}
.branch-panel .v-expansion-panel:not(:first-child)::after {
  border-top: none;
}
.branch-panel .v-expansion-panel-content__wrap {
  padding: 0;
}
.branch-panel .v-treeview-node__checkbox,
.branch-panel .v-treeview-node__content {
  margin-right: 0;
}
.branch-panel .v-treeview-node__content .v-treeview-node__prepend {
  display: none;
}
.branch-panel .v-treeview-node__root {
  gap: 0.25rem;
}
.branch-panel .v-treeview-node__root .v-icon.v-icon::after {
  background-color: transparent;
}
.v-application .accent--text {
  color: #0066ff !important;
  caret-color: #0066ff !important;
}

/* Legacy tab panes scroll under fixed footer; documents fills + inner scroll. */
.app-form-page--customer.app-form-page--fixed .app-form-page__tabs .v-window-item {
  overflow-x: hidden;
  overflow-y: auto;
}
.app-form-page--customer.app-form-page--fixed
  .app-form-page__tabs
  .v-window-item.app-form-documents-pane,
.app-form-page--customer.app-form-page--fixed
  .app-form-page__tabs
  .v-window-item--active.app-form-documents-pane {
  overflow: hidden;
}
.app-form-page--customer.app-form-page--fixed .app-form-toolbar__title {
  font-size: 1.15rem !important;
  line-height: 1.25;
}
.app-form-page--customer .app-form-toolbar__status {
  flex: 0 0 auto;
  align-self: center;
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.app-form-page--customer .app-form-toolbar__status .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.app-form-page--customer .app-form-toolbar__status .v-input__slot {
  margin-bottom: 0 !important;
}
</style>

